import {
  VenueUserRole,
  UserRole,
} from "@ticketingplatform/api/dist/__generated__/globalTypes";
import { DefaultOptionType } from "antd/es/select";
import { useMemo } from "react";

export const useUserFormRoleOptions = (
  isVenueUser?: boolean
): DefaultOptionType[] =>
  useMemo(
    () =>
      Object.keys(isVenueUser ? VenueUserRole : UserRole).map((value) => ({
        value,
        label: value,
      })),
    [isVenueUser]
  );
